exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rui-search .rui-search-head {\n  position: relative;\n  padding-bottom: 30px;\n  margin-top: -12px;\n  margin-bottom: -15px;\n  z-index: 1; }\n\n.rui-search .rui-search-body {\n  padding-top: 30px; }\n", ""]);

